var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0415 12.65V16.35C19.0415 19.47 16.1662 22 12.6189 22C9.07165 22 6.19629 19.47 6.19629 16.35V12.65C6.19629 15.77 9.07165 18 12.6189 18C16.1662 18 19.0415 15.77 19.0415 12.65Z",
    stroke: "#7747E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0415 7.65C19.0415 8.56 18.7945 9.4 18.3597 10.12C17.3025 11.88 15.1287 13 12.6189 13C10.1091 13 7.93534 11.88 6.87808 10.12C6.44332 9.4 6.19629 8.56 6.19629 7.65C6.19629 6.09 6.91759 4.68 8.07366 3.66C9.23962 2.63 10.8403 2 12.6189 2C14.3975 2 15.9982 2.63 17.1642 3.65C18.3202 4.68 19.0415 6.09 19.0415 7.65Z",
    stroke: "#7747E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0415 7.65V12.65C19.0415 15.77 16.1662 18 12.6189 18C9.07165 18 6.19629 15.77 6.19629 12.65V7.65C6.19629 4.53 9.07165 2 12.6189 2C14.3975 2 15.9982 2.63 17.1642 3.65C18.3202 4.68 19.0415 6.09 19.0415 7.65Z",
    stroke: "#7747E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.b61378912ad3a81c6e30407f5e6addbc.svg";
export { ForwardRef as ReactComponent };